"use client"

import { cn } from "../../helpers"
import { paragraph, title } from "../typography"

const drawerFooter = (className?: string) => cn("flex w-full flex-col gap-3", className)

const drawerTitle = (className?: string) =>
  cn(title({ size: "lg", className: "text-center" }), className)

const drawerDescription = (className?: string) =>
  cn(paragraph({ size: "sm", className: "text-center text-neutral-700" }), className)

const drawerTextContainer = cn("flex flex-col gap-2")

const drawerOverlay = cn("fixed inset-0 z-30 bg-neutral-600/60")

const drawerContent = cn(
  "fixed bottom-0 left-0 right-0 z-[60] mt-24 flex flex-col rounded-t-[2rem] bg-white",
)

const drawer = cn("flex-1 rounded-t-[2rem] bg-white p-6")

const drawerHandle = cn(
  "absolute -top-3 left-1/2 mx-auto h-1 w-14 flex-shrink-0 -translate-x-1/2 rounded-full bg-white",
)

const drawerWrapper = cn("flex w-full flex-col gap-4")

const drawerClose = cn("ml-auto")

const drawerCloseIcon = cn("w-5 stroke-2")

const drawerInner = (className?: string) => cn("flex w-full flex-col items-center gap-6", className)

export {
  drawerFooter,
  drawerTitle,
  drawerDescription,
  drawerTextContainer,
  drawerOverlay,
  drawerContent,
  drawer,
  drawerHandle,
  drawerWrapper,
  drawerInner,
  drawerClose,
  drawerCloseIcon,
}
